import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/blacklabelhotels.webp';
import screenshot_target from '../../../images/letterfunnel/martinhendricks.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Martin Hendricks"
      firstname="Martin"
      companyname="Black Label Hotels"
      competition="Odyssey Hotel Group en Sircle Collection"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/martinhendricks.js